export default {
  'Text': 'Testo',
  'Styles': 'Stili',
  'Text here': 'Testo qui',
  'Add subtitles': 'Aggiungi sottotitoli',
  'Text Color': 'Colore testo',
  'Outline': 'Contorno',
  'Background': 'Sfondo',
  'Position': 'Posizione',
}